/* eslint-disable @atlassian/relay/no-wrapping-hooks */
import { graphql, useLazyLoadQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { useFieldNodeQuery } from './__generated__/useFieldNodeQuery.graphql';
import type { JiraIssueFieldConfig } from './JiraFieldCategoryType.types.tsx';
import { readInlineJiraFieldConfig } from './processFields.tsx';

/**
 * Used to grab a node by reading local Relay store
 * Can also be used to fetch from network
 * @param options
 * @returns
 */
export const useFieldNode = (
	initialFetchNodeId: JiraIssueFieldConfig['id'] = '',
	options?: {
		fetchPolicy?: 'store-or-network' | 'network-only' | 'store-only';
	},
) => {
	const { fetchPolicy = 'store-only' } = options ?? {};
	const queryData = useLazyLoadQuery<useFieldNodeQuery>(
		graphql`
			query useFieldNodeQuery(
				$nodeId: ID!
				$skip: Boolean!
				$includeIsForge: Boolean!
				$includeInstalledByAppName: Boolean!
			) {
				node(id: $nodeId) @optIn(to: "JiraCustomFieldsManagement") @skip(if: $skip) {
					... on JiraIssueFieldConfig {
						__typename
						...processFields
							@arguments(
								includeIsForge: $includeIsForge
								includeInstalledByAppName: $includeInstalledByAppName
							)
					}
				}
			}
		`,
		{
			nodeId: initialFetchNodeId,
			skip: !initialFetchNodeId,
			includeIsForge: fg('modify_forge_field_type_display_name'),
			includeInstalledByAppName: fg('cfm_add_app_name'),
		},
		{ fetchPolicy },
	);

	if (!initialFetchNodeId || queryData?.node?.__typename !== 'JiraIssueFieldConfig') return null;

	return readInlineJiraFieldConfig(queryData?.node);
};
